<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>&copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="#" target="_blank" rel="nofollow">Nihon Superior</a>
          <span class="hidden sm:inline-block"> </span>
        </p>
        <span class="md:flex hidden items-center">
            <span>Powered by <a href="https://ideria.co" target="_blank" rel="nofollow">Ideria</a></span>
            <feather-icon icon="ZapIcon" svgClasses="stroke-current text-warning w-6 h-6" class="ml-2" />
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
